import React, { useState, useEffect, useRef } from 'react'
import axios from "axios";
import { APIURL } from "../../../Global";
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css'
import { ToggleButton } from 'react-bootstrap';
import { ToggleButtonGroup } from 'react-bootstrap';
import { Modal } from "react-bootstrap";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import "../AdmissionReport/reports.css";
import "rsuite/dist/rsuite.min.css";
import { DatePicker, DateRangePicker } from "rsuite";
import AvailabityFilter from "./AvailabilityFilter";
import Nav from 'react-bootstrap/Nav';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import { MdDownloadForOffline } from "react-icons/md";
import { GrClose } from "react-icons/gr";

function VolunteerReport() {
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1)
  const [modalShow, setModalShow] = useState(false);
  const [hasNext, setHasNext] = useState(false);
  const [load, setLoad] = useState('')
  const [registerData, setRegisterData] = useState([])
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDate1, setFromDate1] = useState("");
  const [toDate1, setToDate1] = useState("");
  const [selectedJobSkills, setSelectedJobSkills] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [currentDay, setCurrentDay] = useState(moment().format('YYYY-MM-DD'));
  const [currentMonth, setCurrentMonth] = useState(moment().format('MMMM'));
  const [monthsYear, setMonthsYear] = useState(moment().format('YYYY'));
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedYears, setSelectedYears] = useState([]);
  const [selectedDownloads, setSelectedDownloads] = useState([]);
  const [isDownloadDropdownOpen, setIsDownloadDropdownOpen] = useState(false);
  const [dateRange, setDateRange] = useState(null);

  // Filter state management similar to PatientReports
  const hasMounted = useRef(false);
  const isInitialLoad = useRef(true);
  const [filters, setFilters] = useState({
    vo_name: '',
    vo_gender: '',
    vo_address: '',
    vo_experience: '',
    job_skills: '',
    registration: '',
    avail_from: '',
    avail_to: '',
    avail_period: '',
  });
  const prevFiltersRef = useRef(filters);

  // Initial load
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      hasMounted.current = true;
      apiCallFilter(1, perPage, false);
    }
  }, []);

  // Handle filter changes
  useEffect(() => {
    const hasAnyFilter = Object.values(filters).some((value) => value !== '');
    const hadAnyFilter = Object.values(prevFiltersRef.current).some((value) => value !== '');

    if (hasMounted.current && !isInitialLoad.current && (hasAnyFilter || hadAnyFilter)) {
      setPage(1)
      setRegisterData([]);
      apiCallFilter(1, perPage, false);
    }

    prevFiltersRef.current = filters;
  }, [filters, perPage]);

  const handleRefresh1 = () => {
    if (hasMounted.current) {
      setFilters({
        vo_name: '',
        vo_gender: '',
        vo_address: '',
        vo_experience: '',
        job_skills: '',
        registration: '',
        avail_from: '',
        avail_to: '',
        avail_period: '',
      });
      setRegisterData([]);
      apiCallFilter(1, perPage);
      setFromDate("");
      setToDate("");
      setFromDate1("");
      setToDate1("");
      setSelectedValue("");
      setSelectedJobSkills([]);
    }
  }

  // Handle date changes
  useEffect(() => {
    if (hasMounted.current && (fromDate || fromDate1)) {
      setPage(1)
      apiCallFilter(1, perPage);
    }
  }, [fromDate, toDate, fromDate1, toDate1]);

  // Handle job skills changes
  useEffect(() => {
    if (hasMounted.current && selectedJobSkills.length > 0) {
      setPage(1)
      apiCallFilter(1, perPage);
    }
  }, [selectedJobSkills]);

  const downloadOptions = ["PDF", "CSV"];

  const toggleDownloadDropdown = () => {
    setIsDownloadDropdownOpen(!isDownloadDropdownOpen);
  };

  const handleDownloadChange = (download) => {
    setSelectedDownloads((prevDownloads) => {
      if (prevDownloads.includes(download)) {
        return prevDownloads.filter(item => item !== download);
      } else {
        return [...prevDownloads, download];
      }
    });
  };

  const capitalize = (str) => {
    if (typeof str === 'string') {
      return str && str !== "" && str.replace(/\b\w/g, c => c.toUpperCase());
    }
    return str;
  };

  const handleDownloads = () => {
    selectedDownloads.forEach((selectedOption) => {
      if (selectedOption === 'PDF') {
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);
        const title = "Volunteer Report";
        const headers = [["Name", "Gender", "Address", "Occupation", "Job Skills", "Experience", "Registration", "Available From", "Available To", "Available Period"]];

        const data = registerData.map((elt) => {
          return [
            capitalize(elt.full_name),
            capitalize(elt.gender),
            capitalize(elt.address),
            elt.occupation ? capitalize(elt.occupation) : '',
            elt.job_skill.map(capitalize),
            elt.experience ? capitalize(elt.experience) : '',
            elt.register_at,
            elt.avail_from,
            elt.avail_to,
            capitalize(elt.available_period),
          ];
        });

        let content = {
          startY: 50,
          head: headers,
          body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("Volunteer_Report.pdf")

      } else if (selectedOption === 'CSV') {
        const csvData = registerData.map(elt => {
          const job_skill = elt.job_skill || [];
          const rowData = [
            elt.full_name,
            elt.gender || "N/A",
            elt.address || "N/A",
            elt.occupation || "N/A",
            ...(job_skill.length > 0 ? [job_skill.join(", ")] : ["N/A"]),
            elt.experience || "N/A",
            elt.register_at,
            elt.avail_from,
            elt.avail_to,
            elt.available_period
          ];

          return rowData.map(value => `"${value}"`).join(",");
        });

        const csvContent =
          CsvRegisterheaders.map(h => h.label).join(',') +
          '\n' +
          csvData.join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Volunteer_Report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });

    setSelectedDownloads([]);
    setIsDownloadDropdownOpen(false);
  };

  const handleApplyFilter = (selectedSkills, dateRange, dateRange1) => {
    setSelectedJobSkills(selectedSkills.length > 0 ? selectedSkills : []);

    if (dateRange1 && dateRange1[0] !== "") {
      setFromDate(dateRange1[0]);
      setToDate(dateRange1[1]);
    } else {
      setFromDate("");
      setToDate("");
    }

    if (dateRange && dateRange[0] !== "") {
      setFromDate1(dateRange[0]);
      setToDate1(dateRange[1]);
    } else {
      setFromDate1("");
      setToDate1("");
    }

    setRegisterData([]);
  };

  const handleChangeValue = (val) => {
    setRegisterData([]);
    var startOfWeek = moment().startOf('week').toDate();
    var endOfWeek = moment().endOf('week').toDate();
    var FormatedFirstday = moment((startOfWeek)).format('YYYY-MM-DD');
    var Formatedlastday = moment((endOfWeek)).format('YYYY-MM-DD');
    setFromDate1(FormatedFirstday);
    setToDate1(Formatedlastday);
    setSelectedValue('week');
  };

  const handleDayChange = (increment) => {
    setRegisterData([]);
    const newDate = moment(currentDay).add(increment, 'days');

    if (newDate.isAfter(moment(), 'day')) {
      setCurrentDay(moment().format('YYYY-MM-DD'));
      return;
    }

    setFromDate1(newDate.format('YYYY-MM-DD'));
    setToDate1(newDate.format('YYYY-MM-DD'));
    setCurrentDay(newDate.format('YYYY-MM-DD'));
    setSelectedValue('day');
  };

  const handleMonthChange = (increment) => {
    setRegisterData([]);
    const currentMoment = moment(`${monthsYear}-${currentMonth}`, 'YYYY-MMMM');
    const newMoment = currentMoment.add(increment, 'months');

    if (newMoment.isAfter(moment(), 'month')) {
      setCurrentMonth(moment().format('MMMM'));
      setMonthsYear(moment().format('YYYY'));
      return;
    }

    const startOfMonth = newMoment.startOf('month').format('YYYY-MM-DD');
    const endOfMonth = newMoment.endOf('month').format('YYYY-MM-DD');

    setFromDate1(startOfMonth);
    setToDate1(endOfMonth);
    setCurrentMonth(newMoment.format('MMMM'));
    setMonthsYear(newMoment.format('YYYY'));
    setSelectedValue('month');
  };

  const generateYearOptions = () => {
    const startYear = 2023;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear + 2; year++) {
      years.push(String(year));
    }
    return years;
  };

  const filterOptions = [...generateYearOptions()];

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleFilterChange = (filter) => {
    setSelectedYears((cmngYears) => {
      if (cmngYears.includes(filter)) {
        return [];
      } else {
        return [filter];
      }
    });
  };

  const handleApplyFilters = () => {
    setRegisterData([]);

    if (selectedYears.length > 0) {
      const sortedYears = selectedYears.sort((a, b) => Number(a) - Number(b));
      const startDate = sortedYears[0] + '-01-01';
      const endDate = sortedYears[selectedYears.length - 1] + '-12-31';

      setFromDate1(startDate);
      setToDate1(endDate);
    }

    setSelectedYears([]);
    setIsDropdownOpen(false);
    setSelectedValue('');
  };

  const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const apiCallFilter = (page, per_page) => {
    const tokenString = sessionStorage.getItem('usertoken');
    if (!tokenString) {
      setLoad('User token is missing');
      return;
    }

    let str = tokenString.replace(/["]+/g, '');

    // Build search params
    const searchParams = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim() !== '') {
        searchParams[key] = filters[key];
      }
    });

    const skillsParam = selectedJobSkills && selectedJobSkills.length > 0
      ? selectedJobSkills.reduce((acc, skill, index) => {
        acc[`skill[${index}]`] = skill;
        return acc;
      }, {})
      : {};

    axios.get(`${APIURL}/api/v1/service-provider/pv-reports/`, {
      params: {
        start_date: fromDate,
        end_date: toDate,
        start_available: fromDate1,
        end_available: toDate1,
        volunteer: 'volunteer',
        page: page,
        per_page: per_page,
        ...skillsParam,
        ...searchParams
      },
      headers: {
        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.data.status === "success") {
          setHasNext(res.data.has_next);
          setTotalRows(res.data.total_records);
          setLoad('');
          let datalist = res.data.volunteers;

          setRegisterData(datalist);

        } else {
          setLoad('Error in Fetching Data');
        }
      })
      .catch(err => {
        setLoad('Error in Fetching Data');
      });
  };

  const handleEvent = (value, picker) => {
    setDateRange(value);
    setRegisterData([]);

    if (value && value.length === 2) {
      const [start, end] = value;
      const fromDate = moment(start).format('YYYY-MM-DD');
      const toDate = moment(end).format('YYYY-MM-DD');
      setFromDate1(fromDate);
      setToDate1(toDate);
      setSelectedValue('');
    } else {
      setFromDate('');
      setToDate('');
      setFromDate1('');
      setToDate1('');
      setSelectedValue('');
      handleRefresh1()
    }
  };

  // Filter change handler similar to PatientReports
  const handleFilterChange1 = (filterKey, value) => {
    setFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  };

  const renderTable = (cellInfo) => {
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "13px" }}>
        {registerData[cellInfo.index][cellInfo.column.id]}
      </div>
    );
  };

  const renderTableAddress = (cellInfo) => {
    if (registerData && registerData[cellInfo.index] && registerData[cellInfo.index][cellInfo.column.id]) {
      const dataLines = registerData[cellInfo.index][cellInfo.column.id];
      const words = dataLines.split(/[, ]/);

      const lines = [];
      let currentLine = '';

      for (let i = 0; i < words.length; i++) {
        currentLine += words[i] + ' ';
        if ((i + 1) % 2 === 0 || i === words.length - 1) {
          lines.push(currentLine.trim());
          currentLine = '';
        }
      }

      return (
        <div style={{ color: "black", textTransform: "capitalize", fontSize: "13px" }}>
          {lines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  const renderTableExp = (cellInfo) => {
    if (registerData && registerData[cellInfo.index] && registerData[cellInfo.index][cellInfo.column.id]) {
      const dataLines = registerData[cellInfo.index][cellInfo.column.id];
      const words = dataLines.split(/[, ]/);

      const lines = [];
      let currentLine = '';

      for (let i = 0; i < words.length; i++) {
        currentLine += words[i] + ' ';
        if ((i + 1) % 3 === 0 || i === words.length - 1) {
          lines.push(currentLine.trim());
          currentLine = '';
        }
      }

      return (
        <div style={{ color: "black", textTransform: "capitalize", fontSize: "13px" }}>
          {lines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  const handlePopUp = () => {
    setModalShow(false);
  };

  const renderTableJobSkill = (cellInfo) => {
    const skills = registerData[cellInfo.index][cellInfo.column.id];

    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "12px" }}>
        {skills?.map((skill, index) => (
          <div key={index}>{skill},</div>
        ))}
      </div>
    );
  };

  const ConfigPopUp = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
        keyboard={false}
        size='lg'
        dialogClassName="config-modal-width"
        style={{ marginTop: '5rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Modal.Header style={{ height: '50px' }} closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h6 className="title-of-tasks">
              Availability Filter
            </h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AvailabityFilter
            data={registerData}
            fromDate={fromDate}
            toDate={toDate}
            fromDate1={fromDate1}
            toDate1={toDate1}
            updateDateRange={(from, to) => {
              setFromDate(from);
              setToDate(to);
            }}
            handle={handlePopUp}
            onApplyFilter={handleApplyFilter}
          />
        </Modal.Body>
      </Modal>
    );
  };

  const renderDate = (cellInfo) => {
    const datetimeString = cellInfo.value;
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {datetimeString}
      </div>
    );
  };

  const renderDate1 = (cellInfo) => {
    const date = registerData[cellInfo.index][cellInfo.column.id];
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {date}
      </div>
    );
  };

  // Create filter component similar to PatientReports
  const createFilterComponent = (filterKey) => ({ filter, onChange }) => (
    <input
      value={filters[filterKey]}
      onChange={(e) => {
        const filterValue = e.target.value;
        onChange(filterValue);
        handleFilterChange1(filterKey, filterValue);
      }}
      style={{ color: 'black' }}
      placeholder="Search..."
    />
  );

  const columns = [
    {
      Header: "Name",
      accessor: "full_name",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('vo_name'),
      width: 180
    },
    {
      Header: "Gender",
      accessor: "gender",
      Cell: renderTable,
      sortable: true,
      filterable: true,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('vo_gender'),
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: renderTableAddress,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('vo_address'),
      width: 180
    },
    {
      Header: "Occupation",
      accessor: "occupation",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('vo_occupation'),
    },
    {
      Header: "Job Skill",
      accessor: "job_skill",
      Cell: renderTableJobSkill,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('job_skills'),
      width: 200
    },
    {
      Header: "Experience",
      accessor: "experience",
      Cell: renderTableExp,
      sortable: true,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('vo_experience'),
      width: 200
    },
    {
      Header: "Registration",
      accessor: "register_at",
      Cell: renderDate,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: ({ filter, onChange }) => {
        const currentValue = filter?.value || filters.registration || '';
        return (
          <DatePicker
            value={currentValue ? new Date(currentValue) : null}
            onChange={(newDate) => {
              const formattedDate = newDate ? new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : '';
              onChange(formattedDate);
              handleFilterChange1('registration', formattedDate);
            }}
            disabledDate={(date) => date > new Date()}
            format="dd-MM-yyyy"
            cleanable={true}
            oneTap={true}
            maxDate={new Date()}
            placeholder="dd-mm-yyyy"
          />
        );
      },
    },
    {
      Header: "Available From",
      accessor: "available_from",
      Cell: renderDate1,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      sortable: true,
      filterable: false,
    },
    {
      Header: "Available To",
      accessor: "available_to",
      Cell: renderDate1,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: false,

    },
    {
      Header: "Available Period",
      accessor: "available_period",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('avail_period'),
    },
  ];

  const handlePageChange = (pageIndex) => {
    const newPage = pageIndex + 1;
    setPage(newPage);
    apiCallFilter(newPage, perPage);
  };

  const getPageSizeOptions = () => {
    const baseOptions = [10, 20, 25, 50, 100];
    const availableOptions = baseOptions.filter(option => option <= totalRows);

    // Always show at least the first option (10) even if totalRows is less
    if (availableOptions.length === 0) {
      return [10];
    }

    return availableOptions;
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1)
    // registerData.splice(0, registerData.length + 1)
    apiCallFilter(1, newPerPage);
  };
  const RowsPerPageSelector = () => {
    const pageSizeOptions = getPageSizeOptions();
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        fontSize: '14px'
      }}>
        <span style={{ marginRight: '10px' }}>Rows per page:</span>
        <select
          value={perPage}
          onChange={(e) => handlePerRowsChange(Number(e.target.value))}
          style={{
            padding: '5px 10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: 'white',
            color: 'black',
            fontSize: '14px'
          }}
        >
          {pageSizeOptions.map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>
    );
  };


  const handleAvailabityPopUp = (e) => {
    setSelectedJobSkills([]);
    setFromDate("");
    setToDate("");
    setFromDate1("");
    setToDate1("");
    setModalShow(true);
  };

  const handleRefresh = (e) => {
    e.preventDefault();
    setCurrentDay(moment().format('YYYY-MM-DD'));
    setCurrentMonth(moment().format('MMMM'));
    setMonthsYear(moment().format('YYYY'));
    setRegisterData([]);
    setFromDate("");
    setToDate("");
    setFromDate1("");
    setToDate1("");
    setSelectedJobSkills([]);
    handleRefresh1()
    setDateRange(null);
    setSelectedValue('');
    setFilters({
      vo_name: '',
      vo_gender: '',
      vo_address: '',
      vo_experience: '',
      job_skills: '',
      registration: '',
      avail_from: '',
      avail_to: '',
      avail_period: '',
    });
  };

  const handleClear = () => {
    setRegisterData([]);
    setCurrentDay(moment().format('YYYY-MM-DD'));
    setCurrentMonth(moment().format('MMMM'));
    setMonthsYear(moment().format('YYYY'));
    setFromDate("");
    setToDate("");
    setFromDate1("");
    setToDate1("");
    setSelectedJobSkills([]);
    handleRefresh1()
    setDateRange(null);
  };



  const CustomPagination = ({
    page,
    pageSize,
    pages,
    canPrevious,
    canNext,
    onPageChange
  }) => {
    return (
      <div style={{ display: "flex" }}>
        <button style={{ width: "30%", margin: "3px", borderRadius: "5px", padding: "10px" }} onClick={() => onPageChange(page - 1)} disabled={!canPrevious}>
          Previous
        </button>
        <div style={{
          width: "40%",
          textAlign: "center",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px"
        }}>
          <span>Page {totalRows > 0 ? page + 1 : 0} of {pages || 0} </span>
          <RowsPerPageSelector />

        </div>
        <button style={{ width: "30%", margin: "3px", borderRadius: "5px", padding: "10px" }} onClick={() => onPageChange(page + 1)} disabled={!canNext}>
          Next
        </button>
      </div>
    );
  };

  const display = <ReactTable
    columns={columns}
    data={registerData}
    defaultPageSize={perPage}
    className="chol-table"
    resizable
    minRows={0}
    pageSizeOptions={getPageSizeOptions()}
    // pagination
    showPagination={true}
    manual
    // paginationServer
    onPageChange={handlePageChange}
    // paginationTotalRows={totalRows}
    pages={Math.ceil(totalRows / perPage)}
    page={page - 1}
    onPageSizeChange={handlePerRowsChange}
    PaginationComponent={CustomPagination}
  />;

  const CsvRegisterheaders = [
    { label: "Name", key: "full_name" },
    { label: "Gender", key: "gender" },
    { label: "Address", key: "address" },
    { label: "Occupation", key: "occupation" },
    { label: "Job Skills", key: "job_skill" },
    { label: "Experience", key: "experience" },
    { label: "Registration", key: "register_at" },
    { label: "Available From", key: "avail_from" },
    { label: "Available To", key: "avail_to" },
    { label: "Available Period", key: "available_period" },
  ];

  return (
    <>

      <div className="patient-report">
        <Nav className="row"
          style={{
            display: 'inline-block',
            width: '100%',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            margin: 'auto'
          }}>
          <div style={{ display: 'flex', marginTop: "1%" }}>
            <span style={{ float: "left", width: "35rem" }}>
              <button className="buttonfilter" style={{ marginTop: "1%", borderRadius: "25px", width: "90px", background: "#1269B9", fontSize: "11px" }} onClick={(e) => handleRefresh(e)}>
                <span>Refresh &nbsp;<i className="fa fa-refresh" aria-hidden="true" style={{ color: "white" }}></i> </span>
              </button>
            </span>
            <span style={{ display: 'flex', marginBottom: "1%", textAlign: "right", float: "right" }}>
              <ToggleButtonGroup className="datepicker-reports" style={{ marginTop: "1%", fontSize: "small" }} type="radio" name="options" >
                <DateRangePicker
                  appearance="default"
                  placeholder={"Select Date Range"}
                  value={dateRange}
                  onChange={handleEvent}
                >
                  <ToggleButton id="tbg-radio-4" value={'custom'} className="btn btn-light toggle-btns custombtn1" style={{ border: 'none', fontSize: '11px' }}></ToggleButton>
                </DateRangePicker>&nbsp;&nbsp;&nbsp;

                <div style={{ display: 'flex', alignItems: 'center', height: '30px', fontSize: '11px', fontWeight: '400px', border: `1px solid ${selectedValue === 'month' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
                  <button className='arrowButton' onClick={() => handleMonthChange(-1)}>
                    {<AiFillCaretLeft />}
                  </button>
                  <span style={{ margin: '0 4px', width: '50px', textAlign: 'center' }}>{currentMonth}</span>
                  <button className='arrowButton' onClick={() => handleMonthChange(1)}>
                    {<AiFillCaretRight />}
                  </button>
                </div>&nbsp;&nbsp;&nbsp;
                <button
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px', width: '50px', fontSize: '11px', backgroundColor: 'white', fontWeight: '400px', border: `1px solid ${selectedValue === 'week' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}
                  onClick={() => handleChangeValue('week')}
                >
                  <span>Week</span>
                </button>&nbsp;&nbsp;
                <div style={{ position: "relative" }}>
                  <button
                    className="buttonfilter"
                    style={{ borderRadius: "20px", height: '32px', width: '60px', fontSize: '11px', background: isDropdownOpen ? "rgb(13, 197, 197)" : " #1269B9" }}
                    onClick={toggleDropdown}
                  ><span>
                      More
                    </span>
                  </button>&nbsp;
                  {isDropdownOpen && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: '10px',
                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                        zIndex: 99,
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100px',
                        alignItems: 'center',
                      }}
                    >
                      {filterOptions.map((filter) => (
                        <label key={filter} style={{ marginBottom: '5px' }}>
                          <input
                            type="checkbox"
                            checked={selectedYears.includes(filter)}
                            onChange={() => handleFilterChange(filter)}
                            //disable others if one is selected
                            disabled={selectedYears.length > 0 && !selectedYears.includes(filter)}
                          />&nbsp;
                          {filter}
                        </label>
                      ))}
                      <button disabled={selectedYears.length === 0} style={{ marginTop: '10px', cursor: selectedYears.length === 0 ? "not-allowed" : "pointer" }} onClick={handleApplyFilters}>
                        Apply
                      </button>
                    </div>
                  )}</div>
                <div>
                  <button className="buttonfilter" style={{ width: '70px', height: '32px', fontSize: '11px', background: modalShow ? "rgb(13, 197, 197)" : "#1269B9" }} onClick={(e) => handleAvailabityPopUp(e)}>
                    <span>Filters </span>
                  </button>
                  {(selectedJobSkills.length > 0 || fromDate !== '') &&
                    <button
                      className='buttonfilter'
                      style={{
                        width: "80px",
                        backgroundColor: "#1269B9",
                        color: "white",
                        height: "32px",
                        fontSize: "11px",
                        borderRadius: "0px 20px 20px 0px",
                        marginLeft: "-10px"
                      }}
                      onClick={handleClear}
                    ><span>Clear Filters</span>
                    </button>}&nbsp;
                </div>
                <button className='buttonfilter' style={{ width: '100px', height: '32px', fontSize: '11px' }} onClick={setIsDownloadDropdownOpen}>
                  <span>Download  <MdDownloadForOffline /></span>
                </button>
              </ToggleButtonGroup>
            </span></div>
        </Nav>
        {isDownloadDropdownOpen && (
          <div style={{ position: 'relative', zIndex: 1000 }}>
            {/* Backdrop */}
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1000,
              }}
              onClick={() => { }}
            ></div>

            {/* Dropdown */}
            <div className='download-dropdown'
              style={{
                position: 'absolute',
                margin: 'auto',
                width: '30rem',
                borderRadius: '10px',
                backgroundColor: '#fff',
                padding: '10px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                zIndex: 1001,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginLeft: '15rem',
                marginTop: '5%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  borderBottom: '1px solid lightgrey',
                  marginBottom: '10px',
                  paddingBottom: '10px'
                }}
              >
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    marginLeft: 'auto',
                  }}
                  onClick={toggleDownloadDropdown}
                >
                  <GrClose />
                </button>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h4 style={{ marginBottom: "2rem" }}>Select the formats to download</h4>
                {downloadOptions.map((download) => (
                  <label key={download} style={{ marginBottom: '5px' }}>
                    <input
                      type="checkbox"
                      checked={selectedDownloads.includes(download)}
                      onChange={() => handleDownloadChange(download)}
                    />&nbsp;
                    {download}
                  </label>
                ))}
              </div>
              <button
                variant="primary"
                className='buttonfilter'
                style={{ width: '100px', height: '32px', fontSize: '11px', marginTop: "10px" }}
                onClick={handleDownloads}
              >
                Download
              </button>
            </div>
          </div>
        )}
        <div className="service-table-holder" style={{}}> {load === '' ? display
          : load === 'Error in Fetching Data' ? <h6 style={{ color: "red" }}>{load}</h6> : <h6 style={{ color: "grey" }}>{load}</h6>}
        </div>
      </div>
      <br />
      {modalShow ? (
        <ConfigPopUp
          show={modalShow}
          onHide={() => {
            setModalShow(false);
          }}
        />)
        : null}
    </>
  )
}

export default VolunteerReport